import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message, Divider } from 'semantic-ui-react';

import './index.css';

type Props = {
  children?: never;
  setVisible: (value: boolean) => void;
  email: string;
};

export const InvitedMessage: React.FC<Props> = (props) => {
  const { setVisible, email } = props;
  const { t } = useTranslation();

  return (
    <>
      <Message
        className="unactivated-admin"
        info={true}
        onDismiss={() => setVisible(false)}
      >
        <p>
          {t('text.membership.invite.doneWithUnactivated', {
            email,
          })}
        </p>
      </Message>
      <Divider hidden />
    </>
  );
};
